import {ThunkAction} from 'redux-thunk';
import {IStore} from '../interface';
import {Action} from 'redux';
import {getBotAvatars, getUserAvatars, sendVerificationEmail} from '../pageAsyncActions';
import {finishLoadingAction, startLoadingAction} from '../status/actions';
import {getAvatarsApi} from '../api/media';
import {loadMediaAction} from '../media/mediaAsyncActions';
import {
  setBotAvatarsAction, setUserAvatarsAction,
  setVerificationEmailSentAction, updateBotAvatarAction, updateUserAvatarAction
} from './actions';
import {errorHandler} from '../errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';
import {verifyEmail} from '../api/user';

export const loadUserAvatarsAction = (): ThunkAction<void, IStore, unknown, Action> => async (dispatch, getState) => {
  const actionKey = getUserAvatars;

  try {
    dispatch(startLoadingAction(actionKey));
    const {data: userAvatars} = await getAvatarsApi('USER');
    const {media} = getState();

    const updatedAvatars = userAvatars.map((avatar) => {
      if (!avatar.fileUrl) {
        return {
          ...avatar,
          fileUrl: media[avatar.fileId] || ''
        };
      }

      return avatar;
    });

    updatedAvatars.forEach((avatar) => {
      if (!avatar.fileUrl) {
        dispatch(loadMediaAction(
          avatar.fileId,
          (url) => {
            if (url) {
              dispatch(updateUserAvatarAction({
                ...avatar,
                fileUrl: url
              }));
            }
          }
        ));
      }
    });

    dispatch(setUserAvatarsAction(updatedAvatars));
    dispatch(finishLoadingAction(actionKey));
  } catch (e) {
    console.log('user error', e.message);
    dispatch(errorHandler({
      toastKey: ToastKey.GetUserAvatars,
      actionKey: actionKey,
      error: e
    }));
  }
};

export const loadBotAvatarsAction = (): ThunkAction<void, IStore, unknown, Action> => async (dispatch, getState) => {
  const actionKey = getBotAvatars;

  try {
    dispatch(startLoadingAction(actionKey));
    const {data: botAvatars} = await getAvatarsApi('BOT');
    const {media} = getState();

    const updatedAvatars = botAvatars.map((avatar) => {
      if (!avatar.fileUrl) {
        return {
          ...avatar,
          fileUrl: media[avatar.fileId] || ''
        };
      }

      return avatar;
    });

    updatedAvatars.forEach((avatar) => {
      if (!avatar.fileUrl) {
        dispatch(loadMediaAction(
          avatar.fileId,
          (url: string | null) => {
            if (url) {
              dispatch(updateBotAvatarAction({
                ...avatar,
                fileUrl: url
              }));
            }
          }
        ));
      }
    });
    dispatch(setBotAvatarsAction(updatedAvatars));
    dispatch(finishLoadingAction(actionKey));
  } catch (e) {
    console.log('user error', e.message);
    dispatch(errorHandler({
      toastKey: ToastKey.GetBotAvatars,
      actionKey: actionKey,
      error: e
    }));
  }
};

export const sendVerificationEmailAction = (email: string):
  ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const actionKey = sendVerificationEmail;

  try {
    dispatch(startLoadingAction(actionKey));
    const {data} = await verifyEmail(email);

    if (data) {
      dispatch(setVerificationEmailSentAction());
    }
    dispatch(finishLoadingAction(actionKey));
  } catch (e) {
    console.log('sendVerificationEmailAction', e.message);
    dispatch(errorHandler({
      toastKey: ToastKey.SendVerificationEmailAction,
      actionKey,
      error: e,
      currentAction: sendVerificationEmailAction(email)
    }));
    dispatch(finishLoadingAction(actionKey));
  }
});
